import {
  SET_FETCHING_SUBSCRIPTION_DATA,
  SET_GIG_LISTING_DATA,
  SET_GIG_LISTING_SUBSCRIPTION,
  SET_GIG_MODE,
  SET_SELECTED_SLOT,
  SET_SHOW_GIG_BOOKING_FLOW,
} from "./types";

function setGigMode(mode) {
  return { type: SET_GIG_MODE, payload: { mode } };
}

function setGigListingData(listing) {
  return { type: SET_GIG_LISTING_DATA, payload: { listing } };
}

function setGigListingSubscriptionData(subscription) {
  return { type: SET_GIG_LISTING_SUBSCRIPTION, payload: { subscription } };
}

function setShowBookingFLowModal(value) {
  return { type: SET_SHOW_GIG_BOOKING_FLOW, payload: { value } };
}

function setSelectedSlot(value) {
  return { type: SET_SELECTED_SLOT, payload: { value } };
}

function setIsFetchingSubscription(value) {
  return { type: SET_FETCHING_SUBSCRIPTION_DATA, payload: { value } };
}

const Actions = {
  setGigMode,
  setGigListingData,
  setGigListingSubscriptionData,
  setShowBookingFLowModal,
  setSelectedSlot,
  setIsFetchingSubscription,
};

export default Actions;
